export default __webpack_public_path__ + "static/media/dynamic.c7061146.png";